import ReactHTMLTableToExcel from "react-html-table-to-excel";
//components
import Reportes from "./Reportes";
import EstadisticasBoleteria from "./EstadisticasBoleteria";
import { tipoEntrada, totalEntradas, totalInvitados } from "../../../utils/BoleteriaUtils";
import { useState } from "react";
import { format } from "date-fns";

const Boleteria = ({
  evento,
  reportes,
  onClick,
  onChange,
  rol,
  campos,
  extra,
}) => {
  const [mostrarEstadisticas, setMostrarEstadisticas] = useState(false);

  return (
    <>
      <div className="container texto-normal">
        <div className="row">
          <div class="col-md-12 col-12 mb-3 d-md-flex d-block">
            <h1 className="me-md-2 fs-3 text-muted">BOLETERIA</h1>
            <h1 className="fs-3">{evento?.nombre}</h1>
            <div
              className="bg-white p-3 text-center me-md-2 d-none"
              style={{ borderRadius: "20px" }}
            >
              <div className="d-block fw-bold text-muted text-nowrap">
                TOTAL DE VENTAS
              </div>
              <div>
                <span className="fs-6">ARS</span> 0
              </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <div class="input-group ">
              <input
                type="text"
                class="form-control fs-6 p-0 px-2 py-2"
                style={{ borderRadius: "10px" }}
                name="search"
                onChange={(event) => onChange(event)}
              />
              <button
                class="input-group-text fs-6 px-2 p-0 border-0 bg-transparent text-dark"
                id="basic-addon2"
              >
                <i class="bi bi-search"></i>
              </button>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <select
              class="form-select fs-9 p-0 fs-6 px-2 py-2"
              style={{ borderRadius: "10px" }}
              aria-label="Default select example"
              name="fecha"
              onChange={(event) => onChange(event)}
            >
              <option selected>Selecciona una fecha</option>
              {evento
                ? evento.fechasJSON.map((fecha) => (
                  <option value={fecha.fechas[0] + " HORA: " + fecha.hora}>
                    {fecha.fechas[0] + " Hora: " + fecha.hora}
                  </option>
                ))
                : ""}
            </select>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <select
              class="form-select fs-9 p-0 fs-6 px-2 py-2"
              style={{ borderRadius: "10px" }}
              aria-label="Default select example"
              name="status"
              onChange={(event) => onChange(event)}
            >
              <option selected>Seleccionar estado</option>
              <option value="TODOS">Todos</option>
              <option value="ACTIVO">Activos</option>
              <option value="REEMBOLSO">Reembolsados</option>
              <option value="INACTIVO">Inactivos</option>
              <option value="PAUSADO">Pausados</option>
              <option value="LIQUIDADO">Liquidados</option>
              <option value="RECHAZADO">Rechazados</option>
            </select>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <select
              class="form-select fs-9 p-0 fs-6 px-2 py-2"
              style={{ borderRadius: "10px" }}
              aria-label="Default select example"
              name="tipo-entrada"
              onChange={(event) => onChange(event)}
            >
              <option selected>Seleccionar tipo de entrada</option>
              {tipoEntrada(reportes?.data ?? []).map((tipo) => {
                return <option value={tipo.value}>{tipo.label}</option>;
              })}
            </select>
          </div>

          <div className="col-md-12 col-12 mb-3">
            <label className="text-center btn btn-outline-dark py-2 me-2">
              <i class="bi bi-filetype-xls"></i>
              <ReactHTMLTableToExcel
                id="buttonDownloadExcel"
                className="d-none"
                table="boleteriaVentas"
                filename={`${format(new Date(), 'dmmyyyy')}-BOLETERIA`}
                sheet="pagina 1"
                buttonText="Exportar tabla actual"
              />
            </label>

            <label className="text-center btn btn-outline-dark me-2">
              {campos.state ? "Ver menos datos" : "Ver mas datos"}
              <button
                className="d-none"
                name="ver-mas"
                onClick={(event) => onClick(event)}
              ></button>
            </label>

            <label
              className={`text-center btn ${mostrarEstadisticas ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setMostrarEstadisticas(!mostrarEstadisticas)}
            >
              <i class={`bi ${mostrarEstadisticas ? 'bi-table' : 'bi-graph-up-arrow'} me-1`}></i>
              {mostrarEstadisticas ? "Ver tabla" : "Ver estadísticas"}
            </label>
          </div>

          {!mostrarEstadisticas && (
            <>
              <div className="col-md-12">
                <div className="btn w-100 w-lg-auto shadow-sm bg-white p-3 text-center me-lg-2 mb-3">
                  <div className="d-block fw-bold text-muted text-nowrap">
                    TOTAL DE ENTRADAS
                  </div>
                  <div> {reportes ? totalEntradas(reportes).cantidad : 0} </div>
                    <span className="text-muted" style={{fontSize: '10px'}}>Incluye entradas configuradas 2x1</span>
                </div>
                <div className="btn w-100 w-lg-auto shadow-sm bg-white p-3 text-center me-lg-2 mb-3">
                  <div className="d-block fw-bold text-muted text-nowrap">
                    TOTAL VENTAS
                  </div>
                  <div>
                    {" "}
                    {reportes
                      ? `$${parseFloat(
                        totalEntradas(reportes).total
                      ).toLocaleString("es-AR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}`
                      : 0}{" "}
                  </div>
                    <span className="text-muted" style={{fontSize: '10px'}}>Descuentos aplicados ${reportes ? totalEntradas(reportes).descuentos : 0}</span>
                </div>
                <div className="btn w-100 w-lg-auto shadow-sm bg-white p-3 text-center me-lg-2 mb-3">
                  <div className="d-block fw-bold text-muted text-nowrap">
                    TOTAL CONCURRENCIA
                  </div>
                  <div>
                    {" "}
                    {reportes ? `${totalEntradas(reportes).concurrencia} / ${totalEntradas(reportes).cantidad}` : "0 / 0"}{" "}
                  </div>
                </div>
                <div className="btn w-100 w-lg-auto shadow-sm bg-white p-3 text-center me-lg-2 mb-3">
                  <div className="d-block fw-bold text-muted text-nowrap">
                    TOTAL AUSENTES
                  </div>
                  <div>
                    {" "}
                    {reportes ? `${totalEntradas(reportes).ausentes}` : 0}{" "}
                  </div>
                </div>
                <div className="btn w-100 w-lg-auto shadow-sm bg-warning bg-opacity-10 border border-warning p-3 text-center me-lg-2 mb-3">
                  <div className="d-block fw-bold text-warning text-nowrap">
                    <i class="bi bi-gift me-1"></i>
                    TOTAL INVITADOS
                  </div>
                  <div className="text-warning fw-semibold">
                    {" "}
                    {reportes ? `${totalInvitados(reportes)}` : 0}{" "}
                  </div>
                  <span className="text-muted" style={{fontSize: '10px'}}>No incluidos en estadísticas</span>
                </div>
              </div>

              {reportes ? (
                <div className="col-md-12 card d-none d-lg-block mb-4">
                  <Reportes
                    data={reportes}
                    onChange={onChange}
                    onClick={onClick}
                    extra={extra}
                  />
                </div>
              ) : (
                ""
              )}
            </>
          )}

          {/* Sección de Estadísticas */}
          {mostrarEstadisticas && reportes && (
            <div className="col-md-12">
              <EstadisticasBoleteria reportes={reportes} evento={evento} />
            </div>
          )}

          {reportes ? (
            <div className="col-md-12 card d-block d-lg-none mb-4">
              {
                reportes.data.map((reporte, index) => {

                  if (reporte.reporte_codigo.length > 0) {
                    return reporte.reporte_codigo.map((codigo) => {
                      return (
                        <div className="row g-0 mb-3">
                          <div className="col-12 shadow-sm">
                            <div className="card-body p-3">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="flex-grow-1">
                                  <h6 className="card-title mb-1 lh-sm">
                                    {reporte.nombre_cliente}
                                  </h6>
                                  <small className="text-muted">CODIGO#{codigo.codigo}</small>
                                </div>
                              </div>

                              <div className="row g-2 mb-2">
                                <div className="col-4">
                                  <small className="text-muted">CANTIDAD:</small>
                                  <div className="fw-medium small">
                                    {codigo.cantidad}
                                  </div>
                                </div>
                                <div className="col-4">
                                  <small className="text-muted">PRECIO:</small>
                                  <div className="fw-semibold text-success small">
                                    ${parseFloat(reporte.unidad).toLocaleString("es-AR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </div>
                                </div>
                                <div className="col-4">
                                  <small className="text-muted">SUBTOTAL:</small>
                                  <div className="fw-medium small">
                                    {parseFloat(
                                      reporte.unidad * codigo.cantidad
                                    ).toLocaleString("es-AR", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </div>
                                </div>
                              </div>

                              <div className="mb-2">
                                <small className="text-muted d-block">FECHA:</small>
                                <small className="text-muted">
                                  {reporte.fecha}
                                </small>
                              </div>
                              <div className="d-flex justify-content-between align-items-center">
                                <label
                                  className={`
                        ${codigo.ingreso == "ESPERA"
                                      ? "btn btn-outline-secondary fw-bold "
                                      : ""
                                    }
                        ${codigo.ingreso == "CONCURRIO"
                                      ? "btn btn-primary fw-bold"
                                      : ""
                                    }
                        `}
                                >
                                  {codigo.ingreso}
                                  <button
                                    className="d-none"
                                    name="registrar"
                                    onClick={(e) =>
                                      onClick(e, {
                                        ...reporte,
                                        registrar:
                                          codigo.ingreso == "ESPERA"
                                            ? "CONCURRIO"
                                            : "ESPERA",
                                        codigo: codigo.codigo,
                                      })
                                    }
                                  ></button>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                  }
                  return (
                    <div className="row g-0 mb-3">
                      <div className="col-12">
                        <div className="card-body p-3">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div className="flex-grow-1">
                              <h6 className="card-title mb-1 lh-sm">
                                {reporte.nombre_cliente}
                              </h6>
                              <small className="text-muted">CODIGO#{reporte.codigo}</small>
                            </div>
                          </div>

                          <div className="row g-2 mb-2">
                            <div className="col-4">
                              <small className="text-muted">CANTIDAD:</small>
                              <div className="fw-medium small">
                                {reporte.cantidad}
                              </div>
                            </div>
                            <div className="col-4">
                              <small className="text-muted">PRECIO:</small>
                              <div className="fw-semibold text-success small">
                                ${parseFloat(reporte.unidad).toLocaleString("es-AR", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            </div>
                            <div className="col-4">
                              <small className="text-muted">SUBTOTAL:</small>
                              <div className="fw-medium small">
                                {parseFloat(reporte.unidad * reporte.cantidad).toLocaleString(
                                  "es-AR",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="mb-2">
                            <small className="text-muted d-block">FECHA:</small>
                            <small className="text-muted">
                              {reporte.fecha}
                            </small>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <label
                              className={`
                        ${reporte.registro_cliente == "ESPERA"
                                  ? "btn btn-outline-secondary fw-bold "
                                  : ""
                                }
                        ${reporte.registro_cliente == "CONCURRIO"
                                  ? "btn btn-primary fw-bold"
                                  : ""
                                }
                        `}
                            >
                              {reporte.registro_cliente}
                              <button
                                className="d-none"
                                name="registrar"
                                onClick={(e) =>
                                  onClick(e, {
                                    ...reporte,
                                    registrar:
                                      reporte.registro_cliente == "ESPERA"
                                        ? "CONCURRIO"
                                        : "ESPERA",
                                  })
                                }
                              ></button>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              }
            </div>
          ) : (
            ""
          )}

          <div className="d-none" id="reader"></div>
        </div>
      </div>
    </>
  );
};

export default Boleteria;
